import 'jspdf-autotable'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import CitywiseReportCity from './CityWiseReportCity'


const CityWiseReportPage = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route path='city-wise' element={<CitywiseReportCity />} />
        </Route>
        <Route index element={<Navigate to='/report' />} />
      </Routes>
    </>
  )
}

export default CityWiseReportPage
